import { Skeleton, styled, useTheme } from '@mui/material';
import React from 'react';
import Column from '../../../Column';
import Row from '../../../Row';

const AreachartSkeleton: React.FC<{ noYValues?: boolean }> = ({ noYValues }) => {
  const theme = useTheme();
  return (
    <Column style={{ padding: noYValues ? theme.spacing(2, 0) : theme.spacing(0) }} data-testid="AreaChartSkeleton">
      <Row>
        <>
          {!noYValues && (
            <YValuesWrapper>
              {[...Array(5)].map((_, i) => (
                <Skeleton key={`areachart-skeleton-first-${i}`} variant="text" width={30} height={22} />
              ))}
            </YValuesWrapper>
          )}
        </>
        <Column style={{ width: noYValues ? '100%' : '95%', minWidth: 200 }}>
          <Skeleton variant="rectangular" width="100%" height={300} />
        </Column>
      </Row>
      <XValuesWrapper nopaddingleft={noYValues ? 'true' : undefined}>
        {[...Array(10)].map((_, i) => (
          <Skeleton key={`areachart-skeleton-second-${i}`} variant="text" width={22} height={35} />
        ))}
      </XValuesWrapper>
    </Column>
  );
};

export default AreachartSkeleton;

const YValuesWrapper = styled(Column)(({ theme }) => ({
  width: '5%',
  minWidth: '30px',
  alignItems: 'flex-end',
  padding: theme.spacing(0.25, 1.2, 0.25),
  justifyContent: 'space-between',
}));
const XValuesWrapper = styled(Row)<{ nopaddingleft?: 'true' }>(({ theme, nopaddingleft }) => ({
  minWidth: '30px',
  alignItems: 'flex-end',
  justifyContent: 'space-between',
  width: '100%',
  paddingLeft: nopaddingleft === 'true' ? 0 : '5%',
  paddingRight: '3%',
  paddingTop: theme.spacing(1.2),
}));
